<template>
    <div class="header scroll" id="navbar">
        <div class="content">
            <b-navbar toggleable="lg" type="dark">
                <b-navbar-brand to="/"><img src="../assets/img/img_logo.svg" alt="Logo"></b-navbar-brand>

                <b-navbar-toggle target="nav-collapse" @click="movil"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item :to="{name: 'Home', hash: '#acerca'}">Acerca de</b-nav-item>
                        <b-nav-item :to="{name: 'Home', hash: '#cursos'}">Cursos</b-nav-item>
                        <b-nav-item :to="{name: 'Home', hash: '#testimonios'}">Testimonios</b-nav-item>
                        <b-nav-item :to="{name: 'Home', hash: '#clientes'}">Clientes</b-nav-item>
                        <b-nav-item :to="{name: 'Home', hash: '#podcast'}">Podcast</b-nav-item>
                        <b-nav-item to="/Blog">Blog</b-nav-item>
                        <b-nav-item :to="{name: 'Home', hash: '#contacto'}">Contacto</b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav class="ml-auto redes">
                        <b-nav-item href="https://www.facebook.com/hannielventas" target="_blank"><img src="../assets/img/icn_facebook.svg" class="facebook" alt="Facebook"></b-nav-item>
                        <b-nav-item href="https://twitter.com/hannielmaldonad" target="_blank"><img src="../assets/img/icn_twitter.svg" alt="Twitter"></b-nav-item>
                        <b-nav-item href="https://www.instagram.com/hanniel.maldonado/" target="_blank"><img src="../assets/img/icn_instagram.svg" alt="Instagram"></b-nav-item>
                        <b-nav-item href="https://www.youtube.com/channel/UC_tFKCaLfJykRKLejt5m32g" target="_blank"><img src="../assets/img/icn_youtube.svg" alt="Youtube"></b-nav-item>
                        <b-nav-item href="https://mx.linkedin.com/in/hanniel-maldonado-leyva-9b3b5675" target="_blank"><img src="../assets/img/icn_linkedin.svg" alt="Linkedin"></b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            window.onscroll = () => {
                this.color()
            }
            this.color()  
        },
        watch: {
			$route(){
                this.color()
                location.reload(true)
                if(this.$route.name != "Blog"){
                    localStorage.setItem("limit", 9)
                }
			}
		},
        methods: {
            color(){

                if(window.scrollY <= 10){
                    this.transparent();
                }
                else{
                    this.scroll();
                }
            },
            scroll(){
                const nav = document.querySelector('#navbar')
                nav.className = 'header scroll'
            },
            transparent(){
                if(this.$route.name == "Home"){
                    const nav = document.querySelector('#navbar')
                    nav.className = 'header'
                }
                else{
                    this.scroll()
                }
            },
            movil(){
                var x = document.getElementsByClassName("navbar-toggler").getAttribute("aria-expanded"); 
                if (x == "true") {
                    console.log("true");
                }
                else{
                    console.log("false");
                }
            }
        }
    }
</script>

<style scoped>
    .header{
        position: fixed;
        width: 100%;
        z-index: 999;
        transition: background-color 0.4s ease-out;
    }
    .scroll{
        background-color: #171717;
    }
    .navbar{
        padding-left: 0;
        padding-right: 0;
    }
    .navbar-brand img{
        width: 200px;
    }
    .navbar-dark .navbar-nav .nav-link{
        color: white!important;
        font-size: 11pt;
        padding-left: 0;
        padding-right: 0;
        margin-left: 20px;
    }
    .navbar-dark .navbar-nav .nav-link img{
        width: 70%;
    }
    .redes{
        margin-left: 0!important;
    }

    @media screen and (max-width: 991px){
        .header{
            background-color: #171717!important;
        }
        .navbar{
            padding: 0;
        }
        .navbar-brand img{
            width: 150px;;
        }
        .navbar-dark .navbar-nav .nav-link img{
            width: 15px;
        }
        .navbar-dark .navbar-nav .nav-link img.facebook{
            width: 10px;
        }
        .redes{
            flex-direction: row;
            margin-bottom: 20px;
        }
    }
</style>

<style>
    .navbar-dark .navbar-toggler{
        padding: 0;
        border: none;
        outline: none!important;
    }
    .navbar-dark .navbar-toggler-icon{
        background-image: url('../assets/img/icn_menu.svg')!important;
        height: 1.1em!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue